var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-white",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.invite()}}},[_c('i',{staticClass:"fa fa-paper-plane"}),_vm._v(" "+_vm._s(_vm.__('Convidar Usuário'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }